// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.contentModal = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body')
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		};

		methods.initContext = function() {
			methods.setCurrentSettings();
		};


		methods.standardiseYouTubeURL = function(object) {
			$.each(object, function(key, value) {
				var $this = $(this),
					videoUrl = $(this).attr('href'),
					videoId = '',
					rel = 0,
					showinfo = 0,
					modestbranding = 1,
					color = 'white';

				if (videoUrl.indexOf('embed') !== -1) {
					videoId = videoUrl.split('embed/')[1];
				} else if (videoUrl.indexOf('v=') !== -1) {
					videoId = videoUrl.split('v=')[1];

					var ampersandPosition = videoId.indexOf('&');

					if (ampersandPosition != -1) {
						videoId = videoId.substring(0, ampersandPosition);
					}
				} else if (videoUrl.indexOf('youtu.be') !== -1) {
					videoId = videoUrl.split('youtu.be/')[1];
				} else if (videoUrl.length < 15) {
					videoId = videoUrl;
				}

				if (typeof $this.data('rel') !== 'undefined' && $this.data('rel') !== '') {
					rel = $this.data('rel');
				}

				if (typeof $this.data('showinfo') !== 'undefined' && $this.data('showinfo') !== '') {
					showinfo = $this.data('showinfo');
				}

				if (typeof $this.data('modestbranding') !== 'undefined' && $this.data('modestbranding') !== '') {
					modestbranding = $this.data('modestbranding');
				}

				if (typeof $this.data('color') !== 'undefined' && $this.data('color') !== '') {
					color = $this.data('color');
				}

				$this.attr('href', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1' + '&rel=' + rel + '&showinfo=' + showinfo + '&modestbranding=' + modestbranding + '&color=' + color);
			});
		};

		methods.events = function() {

			$context.magnificPopup({
				type: 'ajax',
				mainClass: 'mfp-fade',
				fixedContentPos: true,
				callbacks: {
					ajaxContentAdded: function() {

						var $content = $(this.content);

						methods.standardiseYouTubeURL($('.video-modal, .row .icon'));

						$(document).off('click.contentModal').on('click.contentModal', '.video-modal, .mfp-content .row .icon', function(event) {
							event.preventDefault();
							var $this = $(this);
							var target = $this.attr('href');

							// Close modal and then open it to avoid cross domain issues.
							$.magnificPopup.close();
							$.magnificPopup.open({
								items: {
									src: '<div class="mfp-iframe-scaler"><iframe class="mfp-iframe" width="320" height="240" src="' + target + '" frameborder="0" allowfullscreen></iframe></div>',
									type: 'inline'
								}
							});

						});
					}
				}
			});
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});
	};

	if ($('.content-modal').length) {
		$('.content-modal').contentModal();
	}

}(jQuery));
